// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-status-indicator {
  cursor: pointer;
}

.message-status-indicator .failed {
  color: #d93025;
}

.message-status-indicator .pending {
  color: #6b7280;
}

.message-status-indicator .retrying {
  /* color: #6b7280; */
  color: var(--netsfere-red);
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Messages/MessageStatusIndicator.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B","sourcesContent":[".message-status-indicator {\n  cursor: pointer;\n}\n\n.message-status-indicator .failed {\n  color: #d93025;\n}\n\n.message-status-indicator .pending {\n  color: #6b7280;\n}\n\n.message-status-indicator .retrying {\n  /* color: #6b7280; */\n  color: var(--netsfere-red);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
